export const types = {
  SET_DATA: 'SET_DATA',
  FETCH_HISTORY: 'FETCH_HISTORY',
  SET_CARDS: 'SET_CARDS'
};
